<script setup lang="ts">
import { computed } from 'vue';
import type { OutputLogEvent } from '@models';
import zephyrDashboardLogo from '@assets/images/zephyr-dashboard-logo.png';
import littleArmsLauncherLogo from '@assets/images/little-arms-launcher-logo.png';
/**
 * `TableCellLogApplication` component properties.
 */
export interface Props {
  item: OutputLogEvent;
}

const props = defineProps<Props>();

const application = computed(() => props.item.application);

const webVersion = computed(() => props.item.webVersion);

const apiVersion = computed(() => props.item.apiVersion);

const launcherVersion = computed(() => props.item.launcherVersion);

const simulatorVersion = computed(() => props.item.simulatorVersion);

const launcherTooltip = computed(() => {
  return application.value === 'Little Arms Launcher' ? `\nLAUNCHER | ${launcherVersion.value} SIMULATOR | ${simulatorVersion.value}` : '';
});

const simulatorTooltip = computed(() => {
  return simulatorVersion.value ? `\nZEPHYR | ${simulatorVersion.value}` : '';
});

const webTooltip = computed(() => {
  return webVersion.value ? `\nWEB | ${webVersion.value}` : '';
});

const tooltip = computed(() => {
  return `API | ${apiVersion.value} ${webTooltip.value} ${launcherTooltip.value} ${simulatorTooltip.value}`;
});

</script>

<script lang="ts">
declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellLogApplication: ComponentWithProps<Props>;
  }
}

export default { name: 'TableCellLogApplication' };
</script>

<template>
    <div class="table-cell-application" v-b-tooltip.hover.top="{ customClass: 'tooltip' }" :title="tooltip">
      <img v-if="application === 'Zephyr Dashboard'" :src="zephyrDashboardLogo" :alt="application" />
      <img v-else-if="application === 'Little Arms Launcher'" :src="littleArmsLauncherLogo" :alt="application" />
      <span v-else>{{ application }}</span>
    </div>
</template>

<style scoped lang="scss">
.tooltip {
  // max-width: none !important;
  // width: auto !important;
  white-space: pre-wrap !important;
  font-size: 12px;
  padding: 10px;
}
// :deep(.tooltip-inner) {
//   display: inline-block !important;
//   width: auto !important;
//   max-width: none !important;
//   background-color: rgba(0, 0, 0, 0.85) !important;
//   padding: 20px 20px !important;
// }

.table-cell-application {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 20px;
    height: 20px;
    border-radius: 2px;
  }
}
</style>